import { asMultiStyleConfig } from '../../utils/theme';
var parts = ['button', 'leftIcon', 'rightIcon'];
export var variantPrimary = () => {
  return {};
};
export var variantSecondary = () => {
  return {
    button: {
      display: 'inline-flex',
      alignItems: 'center',
      textAlign: 'inherit',
      border: '1px solid transparent',
      minHeight: 10,
      paddingLeft: 2,
      paddingRight: 2,
      paddingTop: 1,
      paddingBottom: 1,
      borderRadius: '4px',
      fontWeight: 'bold',
      _focus: {
        background: 'none',
        border: '1px solid',
        borderColor: 'blue.200',
        boxShadow: '0 0 3px 2px #4CAAF0'
      }
    }
  };
};
export var baseStyle = {
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    transition: "all 0.15s ease-out",
    cursor: 'pointer',
    textDecoration: 'none',
    letterSpacing: 'tight',
    outline: 'none',
    color: 'blue.600',
    fontWeight: 'semibold',
    _hover: {
      textDecoration: 'underline'
    },
    _focus: {
      boxShadow: 'none',
      outline: 'none',
      bg: 'blue.1140',
      textDecoration: 'underline'
    }
  },
  leftIcon: {
    width: '1em',
    marginRight: 2,
    display: 'inline-flex',
    alignItems: 'center'
  },
  rightIcon: {
    width: '1em',
    marginLeft: 2,
    display: 'inline-flex',
    alignItems: 'center'
  }
};
var defaultProps = {
  variant: 'primary'
};
export default asMultiStyleConfig({
  parts,
  baseStyle,
  defaultProps,
  variants: {
    primary: variantPrimary,
    secondary: variantSecondary
  }
});